import { Pipe, PipeTransform } from '@angular/core';
import { buildResourceTypeDisplayName } from '../../labels/utils';
import { ResourceType } from '../../models/api';

@Pipe({
  name: 'resourceTypeDisplayName',
})
export class ResourceTypeDisplayNamePipe implements PipeTransform {
  /**
   * A pipe to convert a resource type enum into its display value.
   */

  public transform(resourceType?: ResourceType): string {
    return buildResourceTypeDisplayName(resourceType);
  }
}
